// src/pages/stock/Stock.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import StockMovements from './StockMovements';
import CurrentStock   from './CurrentStock';
import ProductHistory from './ProductHistory';
import { ReorderTab, PurchaseOrdersTab, CountsTab, BranchesTab, ExpiryTab, StockAtTab, TurnoverTab } from './InventoryPlus';

const GREEN = '#2e9f86';

export default function Stock() {
  const { t } = useTranslation();

  const tabs = [
    { key: 'movements', label: t('stock.movements', 'Stock Movements'), Comp: StockMovements },
    { key: 'current',   label: t('stock.current',   'Current Stock'),   Comp: CurrentStock   },
    { key: 'history',   label: t('stock.history',   'Product History'), Comp: ProductHistory },
    { key: 'reorder',   label: t('stock.reorder',   '🛒 Reorder'),        Comp: ReorderTab },
    { key: 'po',        label: t('stock.po',        '📨 Purchase Orders'), Comp: PurchaseOrdersTab },
    { key: 'count',     label: t('stock.count',     '📋 Stock Count'),    Comp: CountsTab },
    { key: 'branches',  label: t('stock.branches',  '🏬 Branches'),       Comp: BranchesTab },
    { key: 'expiry',    label: t('stock.expiry',    '⏰ Expiry'),         Comp: ExpiryTab },
    { key: 'stockat',   label: t('stock.at',        '📅 Stock on a date'), Comp: StockAtTab },
    { key: 'turnover',  label: t('stock.turnover',  '🔄 Turnover'),       Comp: TurnoverTab },
  ];

  const [active, setActive] = useState(tabs[0].key);
  const Current = tabs.find(x => x.key === active)?.Comp || (() => null);

  return (
    <div>
      <div className="px-5 pt-5">
        <h1 className="text-2xl font-bold text-gray-800 mb-4">{t('stock.title', 'Stock')}</h1>

        <div className="flex gap-1 border-b overflow-x-auto">
          {tabs.map(tb => {
            const isActive = tb.key === active;
            return (
              <button key={tb.key} onClick={() => setActive(tb.key)}
                className={`px-4 py-2 text-sm font-semibold whitespace-nowrap border-b-2 -mb-px transition
                            ${isActive ? '' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                style={isActive ? { color: GREEN, borderColor: GREEN } : {}}>
                {tb.label}
              </button>
            );
          })}
        </div>
      </div>

      <div className="p-5">
        <Current />
      </div>
    </div>
  );
}